// AI Generated Component
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { LinksRepoService } from '@client/app/services/api/links-repo/links-repo.service';
import { MonNumberPipe } from '@monsido/core/locale/pipes/mon-number.pipe';
import { StateService } from '@uirouter/core';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { ActiveFeatureService } from '@client/ng2/services/active-feature/active-feature.service';
import { PagesFilesPagesComponent } from '@client/app/components/pages/files/pages/pages.component';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';
import {
    MonImgMetadataOverlayComponent,
} from '@monsido/modules/inventory/components/img-metadata-overlay/img-metadata-overlay.component';

/**
 * Inventory content images component
 */
@Component({
    selector: 'inventory-content-images',
    templateUrl: './inventory-content-images.component.html',
    standalone: false,
})
export class InventoryContentImagesComponent extends BaseContainerComponentController implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    // Properties matching original component
    public links: any = [];
    public subheaderTranslation: string = '';
    public tabs: any[] = [];
    public promise: Promise<any> | null = null;
    public domainId: string = '';
    public hasAccessToMetaDataOverlay: boolean = false;

    constructor (
        private linksRepoService: LinksRepoService,
        private translateService: TranslateService,
        private monNumberPipe: MonNumberPipe,
        private stateService: StateService,
        private activeFeatureService: ActiveFeatureService,
    ) {
        super({ table: true, pages: true });
    }

    ngOnInit (): void {
        this.initializeComponent();
    }

    ngOnDestroy (): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private initializeComponent (): void {
        this.links = [];
        this.search = '';
        this.domainId = this.stateService.params.domainId;
        this.subheaderTranslation = '';
        this.hasAccessToMetaDataOverlay = this.activeFeatureService.isFeatureActive('image_metadata');
        this.setupTabs();
        this.getPage();
    }

    private setupTabs (): void {
        this.tabs = [
            {
                name: this.translateService.getString('Internal'),
                value: 'internal',
            },
            {
                name: this.translateService.getString('External'),
                value: 'external',
            },
        ];
        this.activeTab = this.tabs[0].value;
    }

    public override getPage (): void {
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            search: this.search,
            type: 'image',
            relation: this.activeTab,
            status: 'active',
            page_fixed: false,
        };

        this.promise = this.linksRepoService.getAll(params).then((data) => {
            this.links = data;
            this.getSubHeaderDescription();
        });
    }

    private getSubHeaderDescription (): void {
        const total = Number(this.links.total) || 0;
        const formattedNumber = this.monNumberPipe.transform(total, '0,0');
        this.subheaderTranslation = this.translateService.getPlural(
            total,
            '1 result',
            '[[count]] results',
            { count: formattedNumber },
            '',
        );
    }

    public openDialog (link: any, type?: string): void {
        const params = {
            body: PagesFilesPagesComponent,
            size: 'lg',
            data: { link: link, domainId: this.domainId, active: 'image', icon: 'fas fa-file-image', type: type },
        };

        this.monEventsService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }

    public openMetadataModal (link: any): void {
        const params = {
            component: MonImgMetadataOverlayComponent,
            data: { linkUrl: link.url, linkId: link.id },
            dialogOptions: {
                size: 'md',
            },
        };

        this.monEventsService.run(MON_EVENTS.LOAD_NG2_DIALOG, params);
    }
}
